/**
 * Calculate relative luminance of RGB color (0-1 range)
 * Based on WCAG formula: 0.299 * R + 0.587 * G + 0.114 * B
 */
export const getLuminance = (r: number, g: number, b: number): number => {
  return 0.299 * r + 0.587 * g + 0.114 * b;
};